import { Reducer } from 'redux';
import * as Dtos from '../dtos/Tmd.dtos';
import { update } from '../helpers/immutabilityHelper';

import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";
import { ACTION_MEMBERSTATUSES_CLEAR, ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS, ACTION_MEMBERSTATUSES_LOAD_FAILURE, ACTION_MEMBERSTATUSES_LOAD_SUCCESS, MemberStatusesAction } from 'src/actions/memberStatuses';


export interface IMemberStatusState {
    data: {[index: string]: Dtos.MemberStatus};
    loadState: IRequestState;
}

const initialState: IMemberStatusState = {
    data: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IMemberStatusState, _isLoading: boolean): IMemberStatusState {
    const newState: IMemberStatusState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IMemberStatusState,
    data: {[index: string]: Dtos.MemberStatus},
    responseStatus: Dtos.ResponseStatus
): IMemberStatusState {
    const newState: IMemberStatusState = update(state, {
        data: {
            $set: { ...data }
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: IMemberStatusState, responseStatus: Dtos.ResponseStatus): IMemberStatusState {
    const newState: IMemberStatusState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IMemberStatusState, propertiesToClear?: string[]): IMemberStatusState {

    if (!propertiesToClear) {
        const newState: IMemberStatusState = update(initialState, { });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const MemberStatusReducer: Reducer<IMemberStatusState> = (state: IMemberStatusState = initialState, action: MemberStatusesAction) => {
    switch (action.type) {
        case ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS:
            return loading(state, true);
        case ACTION_MEMBERSTATUSES_LOAD_SUCCESS:
            return loadSuccess(state, action.data, action.responseStatus);
        case ACTION_MEMBERSTATUSES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_MEMBERSTATUSES_CLEAR:
            return clear(state, action.propertiesToClear);
    }

    return state;
}

export default MemberStatusReducer;